import React, { useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import AddIcon from '../../img/addRed.svg';
import { useTablet } from '../../hooks/utilHooks';
import WomenWillDialog from './womenWillDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
}));

export default function ScrollableTabsButtonAuto({ history }) {
  const classes = useStyles();
  const isTablet = useTablet();

  const [rotateChevron, setRotateChevron] = useState(false);
  const rotate = rotateChevron ? 'rotate(314deg)' : 'rotate(0)';
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setRotateChevron(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
    setRotateChevron(true);
  };
  return (
    <Box className={classes.root}>
      <img
        alt="Add Icon"
        className="coach-mark-fabIcon-step"
        src={AddIcon}
        style={{
          position: 'fixed',
          bottom: '50px',
          zIndex: '1000',
          cursor: 'pointer',
          transform: rotate,
          transition: 'all 0.2s linear',
          right: isTablet ? '0' : '23%',
        }}
        onClick={open ? handleClose : handleClickOpen}
      />

      <WomenWillDialog open={open} handleClose={handleClose} />
    </Box>
  );
}
